import { render } from "./PlayerNutritionDetail.vue?vue&type=template&id=9c574912&scoped=true"
import script from "./PlayerNutritionDetail.vue?vue&type=script&lang=js"
export * from "./PlayerNutritionDetail.vue?vue&type=script&lang=js"

import "./PlayerNutritionDetail.vue?vue&type=style&index=0&id=9c574912&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c574912"]])

export default __exports__